<template>
    <div>
        <div class="mt-5 mb-5 valid-button">
            <div class="title-valid-button">
                <v-icon color="primary">list</v-icon>
                Prestataires sélectionnés
            </div>
            <div class="mt-3" v-if="providersReadyToImport.length > 1">
                {{ providersReadyToImport.length }} prestataires vont être ajoutés à votre veille.
            </div>
            <div class="mt-3" v-else-if="providersReadyToImport.length === 1">
                1 prestataire va être ajouté à votre veille.
            </div>
            <div class="mt-3" v-else>
                Aucun prestataire n'a été sélectionné pour être ajouté dans votre veille.
            </div>
        </div>

        <div class="mt-5 mb-5 valid-button">
            <div class="title-valid-button">
                <v-icon color="primary">search</v-icon>
                Information utile
            </div>
            <div class="mt-3">
                La prochaine veille aura lieu lundi matin.
            </div>
        </div>

        <div class="d-flex justify-content-end gap-20">
            <v-btn class="default-button" :disabled="providersReadyToImport.length === 0" @click="checkVtcBeforeAddProviders">
                Ajouter
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex"

export default {
    name: "VtcFinalize",
    data() {
        return {}
    },
    methods: {
        ...mapMutations("vtc", [
            "setVtc",
            "resetState",
        ]),
        checkVtcBeforeAddProviders() {
            //verif si vtc existe sinon création avant ajout puis redirection
            this.$global.loading = true
            if (this.vtc.id === undefined) {
                this.createVtc()
            } else {
                this.addProviders()
            }
        },
        createVtc() {
            let payload = {
                userId: this.user.id,
                name: "Veille",
            }

            this.$http.post("veille-tourisme/vtc/create", payload).then(res => {
                this.setVtc(res.body.data.vtc)
                this.addProviders()
            })
        },
        addProviders() {
            let providerIds = this.selectedApidaeSelection === null ?
              this.providersReadyToImport.map(provider => provider.id) :
              this.providersReadyToImport.map(provider => provider.external_id)

            let payload = {
                vtcId: this.vtc.id,
                providersIds: providerIds,
                apidaeSelection: this.selectedApidaeSelection
            }

            this.$http.put("veille-tourisme/vtc/providers/add", payload).then(res => {
                this.resetState()
                this.$global.loading = false
                this.$router.push("/veille/vtc/import-in-progress")
            })
        },
    },
    computed: {
        ...mapState("vtc", [
            "providersReadyToImport",
            "vtc",
            "selectedApidaeSelection",
        ]),
        ...mapState("account", ["account", "user"]),
    },
}
</script>